import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=5905de09"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5905de09')) {
      api.createRecord('5905de09', component.options)
    } else {
      api.reload('5905de09', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=5905de09", function () {
      api.rerender('5905de09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/base-data/code-rule/components/ViewForm.vue"
export default component.exports